import type { RouteRecordRaw } from 'vue-router';

import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import type { AppRouteRecord } from '@/types/core';

export const movementEditRoute: AppRouteRecord = {
  component: () => import('@/views/movement/MovementForm.vue'),
  meta: {
    icon: Icons.Core.Edit,
  },
  name: RouteNames.Movement.Edit,
  path: ':movementUid/edit',
};

export const movementCreateRoute: AppRouteRecord = {
  component: () => import('@/views/movement/MovementForm.vue'),
  meta: {
    icon: Icons.Core.Plus,
  },
  name: RouteNames.Movement.Create,
  path: 'create/:movementType',
};

export const movementListRoute: AppRouteRecord = {
  component: () => import('@/views/movement/MovementList.vue'),
  meta: {
    icon: Icons.Movement,
  },
  name: RouteNames.Movement.List,
  path: '',
};

export const movementRoutes: RouteRecordRaw = {
  children: [
    //
    movementEditRoute,
    movementCreateRoute,
    movementListRoute,
  ],
  path: '/movement',
};
